<template>
  <div>
    <v-stepper v-model="step" vertical>
      <v-stepper-step
        :complete="step > 1"
        :color="step == 1 ? 'primary' : 'success'"
        step="1"
        class="p-3 pb-0"
        >انتخاب طرح
      </v-stepper-step>
      <v-stepper-content step="1">
        <div v-if="subsList.length" class="d-flex flex-column flex-sm-row">
          <div v-for="(subsPlan, index) in subsList" :key="index" class="p-2">
            <v-sheet
              outlined
              :color="
                selectedSubscription && subsPlan.id == selectedSubscription.id
                  ? 'primary'
                  : ''
              "
              rounded
            >
              <v-card
                outlined
                class="item-card"
                @click="selectSubsPlan(subsPlan)"
              >
                <v-card-title v-if="subsPlan">
                  <div
                    class="w-100 d-flex flex-column align-items-center justify-content-center"
                  >
                    <div>
                      <v-img
                        max-height="70px"
                        max-width="70px"
                        class="rounded"
                        :src="
                          subsPlan.logo && subsPlan.logo.thumbnailFileUrl
                            ? subsPlan.logo.thumbnailFileUrl
                            : ''
                        "
                        :alt="
                          subsPlan.logo && subsPlan.logo.alt
                            ? subsPlan.logo.alt
                            : ''
                        "
                      ></v-img>
                    </div>
                    <div>
                      {{ subsPlan.title }}
                    </div>
                    <div>
                      {{ subsPlan.totalPrice.amount | priceSplitter }}
                      {{
                        subsPlan.totalPrice.title
                          ? subsPlan.totalPrice.title
                          : subsPlan.totalPrice.currency
                      }}
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div
                    class="w-100 d-flex flex-column align-items-center justify-content-center"
                  >
                    <div>
                      <span> مدت اشتراک : </span>
                      <strong>{{ subsPlan.durationInMonth }} ماه</strong>
                    </div>
                    <div>
                      <v-btn
                        class="mt-2"
                        color="primary"
                        outlined
                        small
                        @click="showSubscriptionDetail(subsPlan)"
                      >
                        نمایش جزییات
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-sheet>
          </div>
        </div>

        <v-btn
          color="success"
          class="ma-3"
          @click="submitAndGoToNextStep()"
          :disabled="!selectedSubscription"
        >
          ثبت و مرحله بعد
        </v-btn>
      </v-stepper-content>
      <!-- ------------------------------------ -->
      <v-stepper-step
        :complete="step > 2"
        :color="step > 2 ? 'success' : 'primary'"
        step="2"
        class="p-3 pb-0"
      >
        پرداخت
      </v-stepper-step>
      <v-stepper-content step="2">
        <payment-step
          v-if="memberShipPlanData"
          :totalPrice="memberShipPlanData.totalPrice"
          :objectId="objectId"
          sourceType="Membership"
          @getHasPayment="closeForm()"
        ></payment-step>
        <v-row v-else-if="succeed">
          <v-col cols="12">
            <payment-status
              :succeed="succeed"
              :paymentId="paymentId"
              ref="PaymentStatusRef"
            ></payment-status>
          </v-col>
        </v-row>
        <v-card outlined>
          <v-card-title>
            جزییات پلن
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="selectedSubscription">
            <show-detail-subscription
              :selectedToSeeDetail="selectedSubscription"
              :showItem="false"
            ></show-detail-subscription>
          </v-card-text>
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <v-dialog
      v-if="subscriptionDetailDialog"
      v-model="subscriptionDetailDialog"
      max-width="800"
    >
      <v-card outlined>
        <v-card-title>
          جزییات پلن
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="subscriptionDetailDialog = false">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedToSeeDetail">
          <show-detail-subscription
            :selectedToSeeDetail="selectedToSeeDetail"
          ></show-detail-subscription>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="subscriptionDetailDialog = false"
            >بستن</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const subscriptionRepository = () => RepoFactory.get('subscription');
import Helper from '@/core/helpers';
import ShowDetailSubscription from './ShowDetailSubscription.vue';
import PaymentStep from './PaymentStep.vue';
import PaymentStatus from '@/modules/FinancialManagement/wallet/components/PaymentStatus.vue';
export default {
  components: {
    ShowDetailSubscription,
    PaymentStep,
    PaymentStatus,
  },
  data() {
    return {
      selectedToSeeDetail: null,
      step: 1,
      subsList: [],
      selectedSubscription: null,
      subscriptionDetailDialog: false,
      objectId: null,
      memberShipPlanData: null,
    };
  },
  computed: {
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
    paymentBaseUrl() {
      return this.$store.getters.paymentBaseUrl;
    },
    MerchantId() {
      return this.$store.getters.currentMerchant;
    },
    id() {
      return this.$route.params.id;
    },
    succeed() {
      return this.$route.query.succeed == 'true'
        ? true
        : this.$route.query.succeed == 'false'
        ? false
        : undefined;
    },
  },
  created() {
    this.getSubscription();
    if (this.id) {
      this.step = 2;
    }
    if (this.id) {
      this.objectId = this.id;
      this.getMembershipPlanById(this.id);
    }
  },
  watch: {
    memberShipPlanData(after, before) {
      if (after) {
        this.subsList.forEach((element) => {
          if (element.id == after.subscriptionPlanId) {
            this.selectedSubscription = element;
          }
        });
      }
    },
  },
  methods: {
    getMembershipPlanById(id) {
      const loader = this.$loading.show();
      subscriptionRepository()
        .getMembershipPlanById(id, this.subscriptionBaseUrl)
        .then((res) => {
          this.memberShipPlanData = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    closeForm() {
      this.$emit('closeForm');
    },
    submitAndGoToNextStep() {
      this.$dialog.warning({
        text: ` آیا از انتخاب این پلن اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              subscriptionRepository()
                .postData(
                  {
                    subscriptionPlanId: this.selectedSubscription.id,
                  },
                  this.subscriptionBaseUrl,
                  {
                    MerchantId: this.$store.getters.currentMerchant,
                  }
                )
                .then((res) => {
                  console.log(res.data.id);
                  this.objectId = res.data.id;
                  this.getMembershipPlanById(this.objectId);
                  this.step = 2;
                })
                .catch((err) => {
                  //if status code is 422 it shoud redirect to financial-management/subscription page
                  Helper.handleErrors(err, this);
                })
                .finally(() => {
                  loader.hide();
                });
            },
          },
        },
      });
    },
    selectSubsPlan(plan) {
      this.selectedSubscription = plan;
    },
    showSubscriptionDetail(subsPlan) {
      
      this.selectedToSeeDetail = subsPlan;
      this.subscriptionDetailDialog = true;
    },
    getSubscription() {
      const loader = this.$loading.show();
      subscriptionRepository()
        .getSubscriptionPlans(this.subscriptionBaseUrl)
        .then((res) => {
          this.subsList = res.data;

          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
